import magnifiAPIInstance from "./apiInstance";

export const categoryConfigurationAPIs = {
  getCategoryConfigurationById: ({ payload }) => magnifiAPIInstance.get(`/category-configuration/${payload.category}`),
  addCategoryConfiguration: ({ payload }) => magnifiAPIInstance.post(`/api/v3/update-category-configuration`, payload),
  updateCategoryConfiguration: ({ payload }) =>
    magnifiAPIInstance.put(`/api/v3/update-category-configuration`, payload),
  deleteCategoryConfiguration: ({ payload }) =>
    magnifiAPIInstance.delete(`/api/v3/update-category-configuration`, payload),
};
